// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-container {
  height: calc(100vh - 113px);
  overflow-y: auto;
  padding-top: 55px;
  padding-left: 148.5px;
}

.media-icon {
  width: 57.5px;
  height: 57.5px;
  margin-bottom: 14.5px;
}

.media-box {
  width: 125px;
  margin-right: 61.5px;
}

.media-box:last-child {
  margin-right: 0;
}

.media-1-box {
  margin-bottom: 27.5px;
}

.media-1 {
  font-size: 18px;
}

.media-2 {
  font-size: 14px;
  margin-bottom: 6px;
}

.media-2-box {
  margin-bottom: 27px;
}

.media-3 {
  font-size: 12px;
  margin-bottom: 1px;
}

/* .media-3:hover {
  text-decoration: underline;
} */
.media-3-text {
  position: relative;
  display: inline-block;
}

.media-3-text::before {
  content: '';
  /* 가상 요소 내용 없음 */
  position: absolute;
  /* 절대적인 위치 지정 */
  bottom: 0;
  /* 아래에 배치 */
  left: 50%;
  /* 가운데부터 시작 */
  transform: translateX(-50%);
  /* 가운데 정렬 */
  width: 0;
  /* 초기에는 밑줄 크기 0 */
  height: 2px;
  /* 밑줄 높이 조정 */
  background-color: #971B4D;
  /* 밑줄 색상 설정 */
  transition: width 0.5s ease;
  /* 밑줄 크기 변경 애니메이션 */
}

.media-3-text:hover::before {
  width: 100%;
  /* 마우스 오버 시 밑줄 확장 */
}

.media-container-box {
  padding-top: 15px;
}

@media (max-width:1549px) {
  .media-container {
    padding-left: 50px;
  }

  .media-box {
    margin-right: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/media.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;GAEG;AACH;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;EACX,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".media-container {\n  height: calc(100vh - 113px);\n  overflow-y: auto;\n  padding-top: 55px;\n  padding-left: 148.5px;\n}\n\n.media-icon {\n  width: 57.5px;\n  height: 57.5px;\n  margin-bottom: 14.5px;\n}\n\n.media-box {\n  width: 125px;\n  margin-right: 61.5px;\n}\n\n.media-box:last-child {\n  margin-right: 0;\n}\n\n.media-1-box {\n  margin-bottom: 27.5px;\n}\n\n.media-1 {\n  font-size: 18px;\n}\n\n.media-2 {\n  font-size: 14px;\n  margin-bottom: 6px;\n}\n\n.media-2-box {\n  margin-bottom: 27px;\n}\n\n.media-3 {\n  font-size: 12px;\n  margin-bottom: 1px;\n}\n\n/* .media-3:hover {\n  text-decoration: underline;\n} */\n.media-3-text {\n  position: relative;\n  display: inline-block;\n}\n\n.media-3-text::before {\n  content: '';\n  /* 가상 요소 내용 없음 */\n  position: absolute;\n  /* 절대적인 위치 지정 */\n  bottom: 0;\n  /* 아래에 배치 */\n  left: 50%;\n  /* 가운데부터 시작 */\n  transform: translateX(-50%);\n  /* 가운데 정렬 */\n  width: 0;\n  /* 초기에는 밑줄 크기 0 */\n  height: 2px;\n  /* 밑줄 높이 조정 */\n  background-color: #971B4D;\n  /* 밑줄 색상 설정 */\n  transition: width 0.5s ease;\n  /* 밑줄 크기 변경 애니메이션 */\n}\n\n.media-3-text:hover::before {\n  width: 100%;\n  /* 마우스 오버 시 밑줄 확장 */\n}\n\n.media-container-box {\n  padding-top: 15px;\n}\n\n@media (max-width:1549px) {\n  .media-container {\n    padding-left: 50px;\n  }\n\n  .media-box {\n    margin-right: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
